import { useMemo } from "react";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const MARGIN = { top: 10, right: 8, left: -24, bottom: 0 };
const TICK = { fontSize: 10, fontFamily: "JetBrains Mono", fill: "hsl(var(--muted-foreground))" };
const INITIAL_SIZE = { width: 320, height: 200 };
const CURSOR = { fill: "hsl(var(--muted))" };
const tip = { background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", fontFamily: "JetBrains Mono", fontSize: 11 };

export const ActivityChart = ({ data, height = 220, testId = "admin-telemetry-chart" }) => {
  const style = useMemo(() => ({ height }), [height]);
  return (
    <div style={style} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={100} initialDimension={INITIAL_SIZE}>
        <AreaChart data={data} margin={MARGIN}>
          <defs>
            <linearGradient id="auG" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--au-green)" stopOpacity={0.45} />
              <stop offset="100%" stopColor="var(--au-green)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="2 4" vertical={false} />
          <XAxis dataKey="day" tick={TICK} axisLine={false} tickLine={false} />
          <YAxis tick={TICK} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={tip} />
          <Area type="monotone" dataKey="minutes" stroke="var(--au-green)" strokeWidth={2} fill="url(#auG)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export const LanguageChart = ({ data }) => {
  const rows = useMemo(() => data.slice(0, 8).map((d) => ({ ...d, code: d.code.toUpperCase() })), [data]);
  return (
    <div className="h-[220px]" data-testid="admin-language-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={100} initialDimension={INITIAL_SIZE}>
        <BarChart data={rows} margin={MARGIN}>
          <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="2 4" vertical={false} />
          <XAxis dataKey="code" tick={TICK} axisLine={false} tickLine={false} />
          <YAxis allowDecimals={false} tick={TICK} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={tip} cursor={CURSOR} />
          <Bar dataKey="count" fill="var(--au-violet)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
